import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AthleteLayout from "../common/AthleteLayout";
import { AthleteHeader } from "../common/AthleteHeader";
import speedstep2 from "../../images/speedstep2.png";
import workout from "../../images/workout.png";
import demo from "../../images/demo.png";
import video from "../../images/video.svg";
import plus from "../../images/plus.svg";
import upload from "../../images/upload.svg";
import greenClock from "../../images/greenClock.svg";

// --- Icons ---
const ArrowG = () => (
  <svg
    className="hover:opacity-50 cursor-pointer"
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
  >
    <path
      d="M1 13L7 7L1 1"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowL = () => (
  <svg
    className="hover:opacity-50 rotate-180 cursor-pointer"
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
  >
    <path
      d="M1 13L7 7L1 1"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ArrowWhite = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
  >
    <path
      d="M1 1L7 7L13 1"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#fff"
      d="M17 8h-1V6a4 4 0 1 0-8 0v2H7a2 2 0 0 0-2 2v10a2 
         2 0 0 0 2 2h10a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2Zm-5 
         9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm3-9H9V6a3 
         3 0 1 1 6 0v2Z"
    />
  </svg>
);

const Plus = () => {
  return (
    <svg
      width="24"
      className="w-full h-full"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0H24V24H0V0Z" fill="#C19E42" />
      <path d="M11 4.5H13V19.5H11V4.5Z" fill="black" />
      <path d="M4.5 13V11H19.5V13H4.5Z" fill="black" />
    </svg>
  );
};

const Minus = () => {
  return (
    <svg
      width="24"
      className="w-full h-full"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0H24V24H0V0Z" fill="#C19E42" />
      {/* <path d="M10.5 4H13.5V20H10.5V4Z" fill="black" /> */}
      <path d="M4.5 13V11H19.5V13H4.5Z" fill="black" />
    </svg>
  );
};

// --- Data ---
const speedWorkoutData = [
  {
    sets: "1",
    reps: "3",
    distance: "250m",
    time: "34.0",
    rest: "2 min",
    notes: "Focus on drive phase and posture.",
    sprintouts: "3 x 250m sprint",
    workout: "Hill sprints - moderate incline",
  },
  {
    sets: "2",
    reps: "3",
    distance: "250m",
    time: "21.0",
    rest: "2 min",
    notes: "Maintain form under fatigue.",
    sprintouts: "3 x 250m sprint",
    workout: "Flat sprints - timed",
  },
  {
    sets: "3",
    reps: "3",
    distance: "250m",
    time: "21.0",
    rest: "2 min",
    notes: "Final set all out.",
    sprintouts: "3 x 250m sprint",
    workout: "Full effort sprints",
  },
];

// --- SpeedStep3 Component ---
const SpeedStep3 = ({ speedWorkout, handleAccordionClick, openIndex }) => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);

  const closePopup = () => setShowPopup(false);
  const handleLockClick = (index) => {
    if (index !== 0) setShowPopup(true);
  };

  return (
    <div>
      {/* Workout image when collapsed */}
      <div className={`${speedWorkout !== null ? "hidden" : "block"} relative`}>
        {/* <img
          src={workout}
          alt="workout"
          className={`w-full h-full rounded-t-2xl ${
            speedWorkout !== null ? "hidden" : "block"
          }`}
        /> */}
        <div className="flex justify-between items-center text-white w-full bg-black rounded-xl p-3 mb-5">
          <p className="text-base xs:text-xl font-medium">Total Meters</p>
          <p className="text-xs xs:text-sm font-medium">1,050m</p>
        </div>
      </div>

      {/* Workout header when expanded */}
      <div
        className={`${
          speedWorkout !== null ? "block" : "hidden"
        } flex justify-between items-center text-white w-full bg-black rounded-xl p-3 mb-5`}
      >
        <p className="text-base xs:text-xl font-medium">Total Meters</p>
        <p className="text-xs xs:text-sm font-medium">1,050m</p>
      </div>

      <div className="relative">
        {/* label header */}
        <div className="bg-black rounded-xl py-3 px-3 xs:pr-8 divide-x-2 divide-white/50 relative flex flex-row justify-between items-stretch text-center z-10 mb-5">
          <div className="flex-1 px-2">
            <p className="text-[#fcfbfb] text-[10px] xs:text-xs font-light uppercases">
              Sets
            </p>
          </div>
          <div className="flex-1 px-2">
            <p className="text-[#fcfbfb] text-[10px] xs:text-xs font-light uppercases">
              Reps
            </p>
          </div>
          <div className="flex-1 px-2">
            <p className="text-[#fcfbfb] text-[10px] xs:text-xs font-light uppercases">
              Dist.
            </p>
          </div>
          <div className="flex-1 px-2">
            <p className="text-[#fcfbfb] text-[10px] xs:text-xs font-light uppercases">
              T/T
            </p>
          </div>
        </div>
        {/* icon */}
        <div className="absolute top-3 left-2 z-20 cursor-pointer">
          <Link to="/athlete/free-warmup-routine/phase" span className="w-4">
            <BackArrow />
          </Link>
        </div>
      </div>

      {/* Workout Sets Accordion */}
      <div className="flex flex-col relative z-10 space-y-3">
        {speedWorkoutData.map((item, index) => (
          <div
            key={index}
            className={`relative bg-white py-5 px-3 rounded-xl border border-black/30 ${
              index !== 0 ? "blur-[2px]" : ""
            }`}
          >
            {/* Header Row */}
            <div
              className={`flex flex-row justify-between items-center text-center cursor-pointer divide-x-2 divide-black/30  ${
                index !== 0 ? "pointer-events-none" : ""
              } max-xs:-mx-2`}
              onClick={() =>
                index === 0
                  ? handleAccordionClick(index)
                  : handleLockClick(index)
              }
            >
              <div className="space-y-2 flex-1 px-0.5 xs:px-1">
                <label className="text-garyish text-[11px] xs:text-xs font-bold uppercase">
                  Sets
                </label>
                <p className="max-xs:text-xs font-light">{item.sets}</p>
              </div>
              <div className="space-y-2 flex-1 px-0.5 xs:px-1">
                <label className="text-garyish text-[11px] xs:text-xs font-bold uppercase">
                  Reps
                </label>
                <p className="max-xs:text-xs font-light">{item.reps}</p>
              </div>
              <div className="space-y-2 flex-1 px-0.5 xs:px-1">
                <label className="text-garyish text-[11px] xs:text-xs font-bold uppercase">
                  Distance
                </label>
                <p className="max-xs:text-xs font-light">{item.distance}</p>
              </div>
              <div className="space-y-2 flex-1 px-0.5 xs:px-1">
                <label className="text-garyish text-[11px] xs:text-xs font-bold uppercase">
                  T/T
                </label>
                <p className="max-xs:text-xs font-light">{item.time}</p>
              </div>
              <div className="cursor-pointer bg-darkYellow size-4 xs:size-6">
                {/* <Plus /> */}
                {openIndex === index ? <Minus /> : <Plus />}
              </div>
            </div>

            {/* Lock overlay for 2nd & 3rd */}
            {index !== 0 && (
              <div
                className="absolute inset-0 bg-black/30 flex justify-center items-center rounded-md cursor-pointer"
                onClick={() => handleLockClick(index)}
              >
                <LockIcon />
              </div>
            )}

            {/* Expanded Content */}
            {speedWorkout === index && index === 0 && (
              <>
                <div className="pt-3 mt-5 border-t-2 border-darkYellow"></div>

                <div className="text-black text-sm font-medium mb-3">
                  <p>
                    <span className="uppercase">Rest: </span> {item.rest}
                  </p>
                  <p className="mt-1">
                    <span className="uppercase">Notes: </span> {item.notes}
                  </p>
                  <p className="mt-1">
                    <span>Sprintouts:</span> {item.sprintouts}
                  </p>
                  <p className="mt-1">
                    <span>Workout:</span> {item.workout}
                  </p>
                </div>

                {/* Media Section */}
                <div className="w-full flex flex-row gap-4 mb-3">
                  <div className="w-1/2 h-[120px] border border-black/30 rounded-2xl overflow-hidden">
                    <img
                      src={demo}
                      alt="demo"
                      className="object-cover object-[100%_100%]"
                    />
                  </div>
                  <div className="w-1/2 h-[120px] border border-black/30 p-4 rounded-2xl overflow-hidden">
                    <img
                      src={video}
                      alt="video"
                      className="object-contain mb-6 cursor-pointer"
                    />
                    <p className="text-black text-sm font-medium mb-3">
                      Upload video
                    </p>
                    <img
                      src={upload}
                      alt="upload"
                      className="object-contain cursor-pointer"
                    />
                  </div>
                </div>

                {/* Rest Timer */}
                <div className="max-xs:px-0 p-3 flex justify-between items-center">
                  <p className="text-black text-base xs:text-xl font-medium">
                    30 sec
                  </p>
                  <img
                    src={greenClock}
                    alt="greenClock"
                    className="object-contain cursor-pointer w-5"
                  />
                </div>

                {/* Actual Time Input */}
                <div className="max-xs:px-0 p-3 pt-0 flex justify-between items-center">
                  <div className="relative w-full border-b border-black/30">
                    <input
                      type="text"
                      className="placeholder:text-[#5D5D5D] placeholder:font-medium text-black text-base font-light bg-transparent w-full outline-none p-2 pr-12"
                      placeholder="Actual time"
                    />
                    <span className="absolute right-0 top-1/2 -translate-y-1/2 rounded-full size-8 flex justify-center items-center bg-grayish/50 hover:bg-darkYellow transition group">
                      <img
                        src={plus}
                        alt="plus"
                        className="w-4 invert"
                      />
                    </span>
                  </div>
                </div>

                <button className="bg-darkYellow w-full p-3 rounded-full block capitalize text-black text-base xs:text-xl font-medium mt-5">
                  Message the Coach
                </button>
              </>
            )}
          </div>
        ))}
      </div>

      {/* Popup */}
      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center p-3 z-50">
          <div className="bg-white p-4 xs:p-6 rounded-lg shadow-lg max-w-sm w-full text-center">
            <h2 className="text-black text-xl mb-3">
              Your Training Starts Here.
            </h2>
            <p className="text-black font-medium mb-6">
              Upgrade to an AMAX Remote membership and receive fully
              personalized workouts every week.
            </p>
            <div className="flex justify-center gap-4">
              <button
                onClick={() => navigate("/athlete/membership")}
                className="bg-black text-white font-medium text-xs xs:text-sm px-4 py-2 rounded hover:bg-black/70 transition"
              >
                View Memberships
              </button>
              <button
                onClick={closePopup}
                className="border border-gray-400 text-grayish font-medium text-xs xs:text-sm px-4 py-2 rounded hover:bg-grayish/10 transition"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// --- Parent Component ---
export const AthleteFreeSpeedWorkout = () => {
  const navigate = useNavigate();
  const [speedWorkout, setSpeedWorkout] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [openIndex, setOpenIndex] = useState(null);

  // const handleAccordionClick = (index) => {
  // };

  const changeDate = (days) => {
    setSelectedDate((prev) => {
      const newDate = new Date(prev);
      newDate.setDate(prev.getDate() + days);
      return newDate;
    });
  };

  const formatDate = (date) =>
    date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
    });

  const handleAccordionClick = (index) => {
    setSpeedWorkout(speedWorkout === index ? null : index);
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  const handleFreeWarmupClick = () =>
    navigate("/athlete/free-warmup-routine/phase");

  return (
    <AthleteLayout>
      <div className="h-full flex flex-col bg-white">
        <div className="bg-white">
          <AthleteHeader />
        </div>

        {/* Date header */}
        {/* <div className="py-3 flex flex-row justify-center items-center gap-10 bg-white">
          <ArrowL onClick={() => changeDate(-1)} />
          <p className="text-black text-xl">{formatDate(selectedDate)}</p>
          <ArrowG onClick={() => changeDate(1)} />
        </div> */}

        {/* Main */}
        <div className="flex-1 overflow-y-auto ">
          <div className="w-full max-w-2xl px-5 mx-auto">
            <div className="text-white pt-3 mb-4 ">
              {/* Tabs */}
              <div className="bg-[#f5f4f4] rounded-2xl flex justify-between gap-8 px-4 py-4">
                <button
                  onClick={handleFreeWarmupClick}
                  className="text-lightSmock text-sm xs:text-base"
                >
                  Warmup
                </button>
                <button className="text-black text-sm xs:text-base">
                  Workout
                </button>
              </div>
            </div>

            <div className="space-y-4">
              <SpeedStep3
                openIndex={openIndex}
                speedWorkout={speedWorkout}
                handleAccordionClick={handleAccordionClick}
              />
            </div>
          </div>
        </div>
      </div>
    </AthleteLayout>
  );
};

const Arrow = () => {
  return (
    <svg
      class="hover:opacity-50 rotate-180 cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M1 13L7 7L1 1"
        stroke="#fff"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </svg>
  );
};
const BackArrow = () => {
  return (
    <svg
      width="15"
      height="17"
      viewBox="0 0 15 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.42402e-06 7.43949L13.3055 0L14.2816 1.74566L0.976054 9.18515L5.42402e-06 7.43949Z"
        fill="#C19E42"
      />
      <path
        d="M0.896246 7.65482L14.2283 14.3378L13.3321 16.1257L0 9.44277L0.896246 7.65482Z"
        fill="#C19E42"
      />
      <path
        d="M5.42402e-06 7.44266H2.00001V9.44266L0 9.44277L5.42402e-06 7.44266Z"
        fill="#C19E42"
      />
    </svg>
  );
};
